import PractitionerList from './PractitionerList';
import {Provider} from './PractitionerContext';

export const Practitioners = () => {
  return (
    <Provider>
      <PractitionerList />
    </Provider>
  );
};
